.path {
  transition: opacity ease .2s;
}